import OnlineVirtualResearchService from './service';

export * from './reqres';

export default OnlineVirtualResearchService;
